import React, {
  useState,
  useEffect
} from 'react';

import DocumentIcon from '@material-ui/icons/Description';
import ImageIcon from '@material-ui/icons/Image';
import PdfIcon from '@material-ui/icons/PictureAsPdf';

import getDocumentType from '../../../utils/getDocumentType';

function IconByContentType(props: {
  contentType: string;
  size?: "small" | "inherit" | "default" | "large" | undefined;
}) {

  switch (getDocumentType(props.contentType)) {
    case 'image':
      return (<ImageIcon fontSize={props.size} />);
    case 'pdf':
      return (<PdfIcon fontSize={props.size} />);
    default:
      break;
  }

  return (<DocumentIcon fontSize={props.size} />);
}

export {IconByContentType};